import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { EditCanActivate } from "./edit.canactivate";
import { ExamCanActivate } from "./exam.canactivate";
import { EvaluateCanActivate } from "./evaluate.canactivate";
import { ViewCanActivate } from "./view.canactivate";

import { PageLoginComponent } from "src/app/pages/pagelogin/pagelogin.component";
import { PageExamComponent } from "src/app/pages/pageexam/pageexam.component";
import { PageEditLoginComponent } from "src/app/pages/pageeditlogin/pageeditlogin.component";
import { PageEditComponent } from "src/app/pages/pageedit/pageedit.component";
import { PageEvaluateLoginComponent } from "src/app/pages/pageevaluatelogin/pageevaluatelogin.component";
import { PageEvaluateComponent } from "src/app/pages/pageevaluate/pageevaluate.component";
import { PageViewLoginComponent } from "src/app/pages/pageviewlogin/pageviewlogin.component";
import { PageViewComponent } from "src/app/pages/pageview/pageview.component";

const routes: Routes = [
  { path: "login/:id", component: PageLoginComponent },
  { path: "exam/:id", component: PageExamComponent, canActivate: [ExamCanActivate] },
  { path: "testexam/:id", component: PageExamComponent },
  { path: "editlogin/:id", component: PageEditLoginComponent },
  { path: "edit/:id", component: PageEditComponent, canActivate: [EditCanActivate] },
  { path: "evaluatelogin/:id", component: PageEvaluateLoginComponent },
  { path: "evaluate/:id", component: PageEvaluateComponent, canActivate: [EvaluateCanActivate] },
  { path: "viewlogin/:id", component: PageViewLoginComponent },
  { path: "view/:id", component: PageViewComponent, canActivate: [ViewCanActivate] },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes), //
  ],
  exports: [
    RouterModule, //
  ],
  providers: [
    EditCanActivate, //
    ExamCanActivate,
    EvaluateCanActivate,
    ViewCanActivate,
  ],
})
export class AppRouterModule {}
